import React from "react";

export default function Nomoviefound() {
    return (
        <>
            <header className="noMovieFound">
                <h1>No Movie Found</h1>
            </header>
        </>
    )
}